import { useAppToast } from "@/hooks/useAppToast";
import { catchErrorHandler, removeLocalStorageData } from "@picovico/utils";
import { useLogoutUserMutation } from "@store/services/auth";
import { useAppDispatch } from "store/hooks";
import { logOutAction } from "store/slices/userSlice";

// Ends the session server-side (auth/logout) before clearing it locally.
// Resolves true once the user is logged out, false if the API call failed
// and the session was kept.
function useLogout() {
  const dispatch = useAppDispatch();
  const { error: errorToast } = useAppToast();
  const [logoutUser, { isLoading }] = useLogoutUserMutation();

  const logout = async () => {
    try {
      await logoutUser().unwrap();
    } catch (err: any) {
      // A 401 means the session is already dead server-side, so clearing
      // it locally is still correct; anything else keeps the user logged in.
      if (err?.status !== 401) {
        catchErrorHandler(err, errorToast);
        return false;
      }
    }
    dispatch(logOutAction());
    removeLocalStorageData("token");
    return true;
  };

  return { logout, isLoading };
}

export default useLogout;
